import type { Option } from '@usealloy/component-library';

export const NUMERIC_VALUE_MIN = -50000000;
export const NUMERIC_VALUE_MAX = 50000000;

export const configureReasonCodeGroupOption: Option = {
  label: 'Configure Reason Code Groups',
  value: 'configure_reason_code_groups',
  ctaElementProps: {
    style: {
      color: 'var(--cl-juicyBlue-600)',
    },
  },
};
